const prodConfig = {
  url: "https://english-card-test.herokuapp.com/",
};

export { prodConfig };
